import type { ReadonlyURLSearchParams } from 'next/navigation'
import { type QueryKey } from './productList.types'

export function getProductListSource({
  searchParams,
  pageListAnalytics,
  queryKey,
}: {
  searchParams: ReadonlyURLSearchParams
  pageListAnalytics: {
    title: string
  }
  queryKey: QueryKey
}): string {
  const hasSearchParams = !!searchParams.get('q')
  const sourceLabel = queryKey === 'brand' ? 'page marque' : 'liste'

  return hasSearchParams
    ? searchParams.get('filter')
      ? `résultat de recherche filtré | ${searchParams.get('q')}`
      : `résultat de recherche non-filtré | ${searchParams.get('q')}`
    : searchParams.get('filter')
      ? `${sourceLabel} filtrée | ${pageListAnalytics.title}`
      : `${sourceLabel} | ${pageListAnalytics.title}`
}
